<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header"><h5>Ревизия склада</h5></div>
      <div class="card-body">
        <div class="form-group">
          <label for="">Поиск препарата</label>
          <input placeholder="Введите название для поиска" type="text" @keyup="filterDrugs" class="form-control"
                 v-model="searchDrugText">
        </div>
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <table class="table table-sm table-hover mt-1" v-if="!loading">
          <thead>
          <tr>
            <th></th>
            <th></th>
            <th>Препарат</th>
            <th>Комплектность</th>
            <th>На складе</th>
            <th>Ревизия</th>
            <th>Срок годности</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(r, i) in filteredRecords">
            <td>{{ i + 1 }}</td>
            <td>
              <v-popover
                v-if="drugsImages[r.drug.id]"
                class="d-inline"
                placement="bottom"
                :auto-hide="true"
              >
                <i class="icon-fa icon-fa-photo pointer"></i>
                <template slot="popover">
                  <img :src="drugsImages[r.drug.id]" alt="">
                </template>
              </v-popover>
            </td>
            <td>
              <p>{{ r.drug.title }}</p>
              <p>{{ r.drug.en_title }}</p>
              <p class="text-muted" v-if="r.drug.pack_comment">{{ r.drug.pack_comment }}</p>
              <p class="text-muted" v-if="r.drug.pack_box_comment">{{ r.drug.pack_box_comment }}</p>
              <p v-if="r.drug.cool"><i class="icon icon-snowflake pull-left mr-2"/> Требуется хладоген</p>
            </td>
            <td>
              <span class="badge badge-info" v-if="r.drug.pack_set != 1">1 комплект ({{
                  +r.drug.pack_set
                }} зав.уп.)</span>
            </td>
            <td>
              <input type="text" disabled v-model="r.qty" class="form-control">
            </td>
            <td>
              <input type="number" @change="updateRecord(r.drug_id, 'qty')"
                     v-model="revisionRecords[r.drug_id].revisionQty"
                     class="form-control">
            </td>
            <td>
              <template v-for="(ex, i) in revisionRecords[r.drug_id].expireDates">
                <template v-if="i === 0">
                  <div class="input-group">
                    <input v-mask="expireMask" @change="updateRecord(r.drug_id, 'expireDate')" type="text"
                           v-model="ex.date" placeholder="12.2025" class="form-control"/>
                    <div class="input-group-append">
                      <button @click="addNewDate(r.drug_id)" class="btn btn-outline-success btn-xs">
                        <i class="icon-fa icon-fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <input v-mask="expireMask" placeholder="12.2025" @change="updateRecord(r.drug_id, 'expireDate')"
                         type="text"
                         v-model="ex.date" class="form-control"/>
                </template>
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>

import api from "@/api";
import moment from "moment";

export default {
  data() {
    return {
      currentRevision: null,
      expireMask: [/[0-1]/, '#.', /[2-2]/, /[0-0]/, '##'],
      loading: false,
      storeRecords: null,
      filteredRecords: null,
      searchDrugText: null,
      revisionRecords: {},
      drugsImages: {},
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    filterDrugs() {
      if (this.searchDrugText) {
        const searchText = this.searchDrugText.toLowerCase();
        this.filteredRecords = this.storeRecords.filter((d) => (d.drug.en_title ?? '').toLowerCase().includes(searchText) || (d.drug.title ?? '').toLowerCase().includes(searchText))
      } else {
        this.filteredRecords = [...this.storeRecords];
      }
    },
    addNewDate(drugId) {
      this.revisionRecords[drugId].expireDates.push({date: ""});
    },
    async updateRecord(drugId, action) {
      // console.log(drugId, action);
      if (action === 'expireDate') {
        let pass = true;
        this.revisionRecords[drugId].expireDates.forEach((e) => {
          if (!e.date) return;
          if (e.date.length !== 7) pass = false;
        })
        if (!pass) {
          toastr['warning']('срок годности введен не верно', 'Ошибка');
          return;
        }
      }
      const {data} = await api.post('/stores/updateRevision', {
        action,
        revision_id: this.currentRevision.id,
        drug_id: drugId,
        drugData: this.revisionRecords[drugId]
      })
      if (data.success) {
        toastr['success']('обновлено', 'Успешно');
      }
    },
    async getRecords() {
      this.loading = true;
      const userDetails = this.$UserDetails.find((d) => d.alias === 'division_id');
      const storeId = this.$AllDivisions[(userDetails?.details ?? 1)].stores[0].object_id;
      const {data} = await api.index('/stores/lastActiveRevision/' + storeId);
      if (data.success) {
        this.revisionRecords = data.storeRecords.reduce((acc, r) => {
          acc[r.drug_id] = {qty: r.qty, revisionQty: "", expireDates: [{date: ""}]}
          return acc;
        }, {})
        data.revision?.details.forEach((d) => {
          if (!this.revisionRecords[d.drug_id]) {
            this.revisionRecords[d.drug_id] = {qty: 0, revisionQty: "", expireDates: [{date: ""}]}
          }
          this.revisionRecords[d.drug_id].revisionQty = d.actual_qty;
          this.revisionRecords[d.drug_id].record_id = d.id;
        })
        data.expireDates.forEach((e) => {
          if (!this.revisionRecords[e.drug_id].expireDates[0].date) {
            this.revisionRecords[e.drug_id].expireDates[0] = {date: moment(e.expire_date).format('MM.YYYY'), id: e.id}
          } else {
            this.revisionRecords[e.drug_id].expireDates.push({date: moment(e.expire_date).format('MM.YYYY'), id: e.id})
          }
        })
        this.currentRevision = {id: data.revision.id};
        this.drugsImages = data.drugsImages;
        this.storeRecords = _.orderBy(data.storeRecords, 'drug.title');
        this.filteredRecords = [...this.storeRecords];
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
table.table td {
  padding: 3px;
}

table th, .table td, .table input {
  font-size: 0.8rem;
}
</style>
